import { render, staticRenderFns } from "./LocaleSectionEntry.vue?vue&type=template&id=a8d258ae&scoped=true"
import script from "./LocaleSectionEntry.vue?vue&type=script&lang=js"
export * from "./LocaleSectionEntry.vue?vue&type=script&lang=js"
import style0 from "./LocaleSectionEntry.vue?vue&type=style&index=0&id=a8d258ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d258ae",
  null
  
)

export default component.exports